<nav class="navbar navbar-expand navbar-dark navPostion">
  <div class="container-fluid">
    <div>
      
    </div>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-auto align-items-center">
        <li class="nav-item">
          <div class="btn-group language-switcher" role="group" aria-label="Language switch buttons">
            <button type="button" class="btn btn-lang" (click)="switchLang('zh-HK')"
              [class.active]="translate.currentLang === 'zh-HK'"
              [title]="'LANGUAGES.TRADITIONAL_CHINESE_HK' | translate">
              {{ 'LANGUAGES_SHORT.TRADITIONAL_CHINESE_HK' | translate }}
            </button>
            <button type="button" class="btn btn-lang" (click)="switchLang('zh-CN')"
              [class.active]="translate.currentLang === 'zh-CN'" [title]="'LANGUAGES.SIMPLIFIED_CHINESE' | translate">
              {{ 'LANGUAGES_SHORT.SIMPLIFIED_CHINESE' | translate }}
            </button>
            <button type="button" class="btn btn-lang" (click)="switchLang('en')"
              [class.active]="translate.currentLang === 'en'" [title]="'LANGUAGES.ENGLISH' | translate">
              {{ 'LANGUAGES_SHORT.ENGLISH' | translate }}
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>